var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMinimizeModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path579",
    d: "M0-682.665H16v16H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g573",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g575",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g577",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g583",
    transform: "translate(0.625 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path585",
    d: "M-234.374,0H-240V5.625",
    transform: "translate(239.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g587",
    transform: "translate(9.75 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path589",
    d: "M0,0H5.625V5.625",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g591",
    transform: "translate(0.625 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path593",
    d: "M0,0,6.125,6.125",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g595",
    transform: "translate(9.25 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path597",
    d: "M0-255.208l6.125-6.125",
    transform: "translate(0 261.333)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g599",
    transform: "translate(0.625 9.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path601",
    d: "M-234.374-234.374H-240V-240",
    transform: "translate(239.999 239.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g603",
    transform: "translate(9.75 9.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path605",
    d: "M0-234.374H5.625V-240",
    transform: "translate(0 239.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g607",
    transform: "translate(0.625 9.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path609",
    d: "M0-255.208l6.125-6.125",
    transform: "translate(0 261.333)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g611",
    transform: "translate(9.25 9.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path613",
    d: "M0,0,6.125,6.125",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMinimizeModal);
export default __webpack_public_path__ + "static/media/expand-minimize-modal.0aab5d6cee4e1fc066d11223714b8dbb.svg";
export { ForwardRef as ReactComponent };